import { render, staticRenderFns } from "./chart-referal-amount-inverted.vue?vue&type=template&id=d0f03d5a&"
import script from "./chart-referal-amount-inverted.vue?vue&type=script&lang=js&"
export * from "./chart-referal-amount-inverted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports